/* YEMAT PDP behaviour — paired with sections/ymt-pdp.liquid.
   Reads its config from the <script type="application/json" data-ymtp-cfg> inside the section.
   No dependencies. */
(function () {
  'use strict';

  var LABEL = {
    inStock:  'In stock — ready to dispatch',
    outSize:  'Unavailable in this size',
    soldOut:  'Sold out',
    pickSize: 'Select a size',
    pickSizeErr: 'Please select a size',
    atc:      'Add to cart',
    atcSold:  'Sold out',
    adding:   'Adding…',
    failed:   'Could not add to cart.'
  };

  function init(root) {
    if (!root || root.getAttribute('data-ymtp-init') === '1') return;
    root.setAttribute('data-ymtp-init', '1');

    var cfgEl = root.querySelector('[data-ymtp-cfg]');
    var CFG = { variants: [], sizeIndex: 0, colourIndex: -1, hasColour: false, productAvailable: false };
    if (cfgEl) { try { CFG = JSON.parse(cfgEl.textContent); } catch (e) {} }

    var form     = root.querySelector('[data-ymtp-form]');
    var idInput  = root.querySelector('[data-ymtp-id]');
    var atc      = root.querySelector('[data-ymtp-atc]');
    var stock    = root.querySelector('[data-ymtp-stock]');
    var stockTxt = root.querySelector('[data-ymtp-stock-text]');
    var priceAmt = root.querySelector('[data-ymtp-amount]');
    var priceCmp = root.querySelector('[data-ymtp-compare]');
    var errEl    = root.querySelector('[data-ymtp-err]');
    var sizesBox = root.querySelector('[data-ymtp-sizes]');
    var errTimer = null;

    function sizeInputs()   { return root.querySelectorAll('.ymtp-size-input'); }
    function colourInputs() { return root.querySelectorAll('.ymtp-colour-input'); }
    function checkedVal(list) { for (var i = 0; i < list.length; i++) { if (list[i].checked) return list[i].value; } return null; }

    function variantById(id) {
      for (var i = 0; i < CFG.variants.length; i++) { if (String(CFG.variants[i].id) === String(id)) return CFG.variants[i]; }
      return null;
    }
    function currentColour() {
      if (!CFG.hasColour) return null;
      var c = checkedVal(colourInputs());
      if (c) return c;
      var v = variantById(idInput ? idInput.value : null);
      return v ? v.options[CFG.colourIndex] : null;
    }
    function findVariant(size, colour) {
      for (var i = 0; i < CFG.variants.length; i++) {
        var v = CFG.variants[i];
        if (size !== null && v.options[CFG.sizeIndex] !== size) continue;
        if (CFG.hasColour && colour !== null && v.options[CFG.colourIndex] !== colour) continue;
        return v;
      }
      return null;
    }

    /* size availability follows the selected colour */
    function refreshSizeAvailability() {
      var colour = currentColour();
      var inputs = sizeInputs();
      for (var i = 0; i < inputs.length; i++) {
        var inp = inputs[i];
        var wrap = inp.parentNode;
        var v = findVariant(inp.value, colour);
        var ok = !!(v && v.available);
        inp.disabled = !ok;
        if (ok) { inp.removeAttribute('aria-disabled'); } else { inp.setAttribute('aria-disabled', 'true'); }
        if (wrap && wrap.classList) wrap.classList.toggle('is-out', !ok);
        if (!ok && inp.checked) inp.checked = false;
      }
    }

    /* exactly one stock state is ever in the DOM */
    function setStock(state, text) {
      if (!stock) return;
      stock.setAttribute('data-state', state);
      if (stockTxt) stockTxt.textContent = text;
    }

    function sync() {
      var hasSizes = sizeInputs().length > 0;
      var size   = hasSizes ? checkedVal(sizeInputs()) : null;
      var colour = currentColour();
      var v = (hasSizes && size === null) ? null : findVariant(size, colour);

      if (idInput) { idInput.value = v ? v.id : ''; }   /* empty until a size is chosen */

      if (v) {
        if (priceAmt) priceAmt.textContent = v.price;
        if (priceCmp) {
          if (v.compare) { priceCmp.textContent = v.compare; priceCmp.style.display = ''; }
          else { priceCmp.style.display = 'none'; }
        }
      }

      if (!CFG.productAvailable)          { setStock('out',  LABEL.soldOut); }
      else if (hasSizes && size === null) { setStock('none', LABEL.pickSize); }
      else if (v && v.available)          { setStock('in',   LABEL.inStock); }
      else                                { setStock('out',  LABEL.outSize); }

      var canBuy = !!(v && v.available);
      var noSizeYet = hasSizes && size === null;
      /* "Sold out" is only ever shown for a chosen-but-unavailable variant. With no size
         chosen the button stays live so a click scrolls to and highlights the size row. */
      if (atc) {
        atc.disabled = !canBuy && !noSizeYet;
        atc.textContent = (canBuy || noSizeYet) ? LABEL.atc : LABEL.atcSold;
      }

      document.dispatchEvent(new CustomEvent('ymtp:variant', {
        detail: {
          variant: v || null,
          size: size,
          available: canBuy || noSizeYet,
          price: v ? v.price : (priceAmt ? priceAmt.textContent : '')
        }
      }));
    }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.classList) return;
      if (t.classList.contains('ymtp-colour-input')) { refreshSizeAvailability(); sync(); }
      else if (t.classList.contains('ymtp-size-input')) { sync(); }
    });

    /* ---------------- add to cart ---------------- */
    function showErr(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.style.display = 'block';
      clearTimeout(errTimer);
      errTimer = setTimeout(function () { errEl.style.display = 'none'; }, 6000);
    }
    function updateCartCount(cart) {
      if (!cart || typeof cart.item_count !== 'number') return;
      var els = document.querySelectorAll('.cart-count');
      for (var i = 0; i < els.length; i++) { els[i].textContent = cart.item_count; }
    }
    /* No size chosen: outline the size group, say why, and move focus there. Used by the main
       button, by the sticky mobile bar (via the ymtp:focus-size event) and by the size button. */
    function flashSizes() {
      if (!sizesBox) return;
      sizesBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      sizesBox.classList.add('ymtp-flash');
      setTimeout(function () { sizesBox.classList.remove('ymtp-flash'); }, 1400);
      showErr(LABEL.pickSizeErr);
      var inputs = sizeInputs();
      for (var i = 0; i < inputs.length; i++) {
        if (!inputs[i].disabled) { try { inputs[i].focus({ preventScroll: true }); } catch (err) { inputs[i].focus(); } break; }
      }
    }
    function sizeMissing() { return sizeInputs().length > 0 && checkedVal(sizeInputs()) === null; }
    document.addEventListener('ymtp:focus-size', flashSizes);

    if (form) {
      form.addEventListener('submit', function (e) {
        /* Never submit without an explicit size — with or without fetch. */
        if (sizeMissing() || !idInput || !idInput.value) { e.preventDefault(); flashSizes(); return; }
        if (!window.fetch) return;               /* no fetch: let the form post normally */
        e.preventDefault();
        if (atc && atc.disabled) return;
        if (errEl) errEl.style.display = 'none';
        if (atc) { atc.disabled = true; atc.textContent = LABEL.adding; }
        /* Flag the in-flight add so /cart can wait for it instead of rendering a stale empty cart. */
        try { sessionStorage.setItem('ymt:cart-pending', String(Date.now())); } catch (e) {}

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] }),
          credentials: 'same-origin'
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || LABEL.failed);
            return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            updateCartCount(cart);
            document.dispatchEvent(new CustomEvent('cart:change', { detail: cart }));
            if (typeof window.openCartDrawer === 'function') { window.openCartDrawer(); }
            else if (typeof window.updateCart === 'function') { window.updateCart(); }
          })
          .catch(function (err) { showErr(err && err.message ? err.message : LABEL.failed); })
          .then(function () { try { sessionStorage.removeItem('ymt:cart-pending'); } catch (e) {} sync(); });
      });
    }

    /* ---------------- gallery dots ---------------- */
    var track = root.querySelector('[data-ymtp-track]');
    var dotsBox = root.querySelector('[data-ymtp-dots]');
    if (track && dotsBox) {
      var dots = dotsBox.querySelectorAll('.ymtp-dot');
      for (var d = 0; d < dots.length; d++) {
        (function (dot) {
          dot.addEventListener('click', function () {
            var i = Number(dot.getAttribute('data-i'));
            var shot = track.children[i];
            if (shot) track.scrollTo({ left: shot.offsetLeft, behavior: 'smooth' });
          });
        })(dots[d]);
      }
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var w = track.clientWidth || 1;
          var i = Math.round(track.scrollLeft / w);
          for (var j = 0; j < dots.length; j++) {
            if (j === i) dots[j].setAttribute('aria-current', 'true');
            else dots[j].removeAttribute('aria-current');
          }
        });
      }, { passive: true });
    }

    /* the theme scrolls <body>, not <html>, so lock both while an overlay is open */
    function lockScroll(on) {
      var v = on ? 'hidden' : '';
      document.documentElement.style.overflow = v;
      document.body.style.overflow = v;
    }

    /* ---------------- lightbox ---------------- */
    var lb = root.querySelector('[data-ymtp-lb]');
    var lbImg = lb ? lb.querySelector('[data-ymtp-lb-img]') : null;
    function openLb(src, alt) {
      if (!lb || !lbImg) return;
      lbImg.src = src; lbImg.alt = alt || '';
      lb.hidden = false; lb.classList.add('is-open');
      lockScroll(true);
    }
    function closeLb() {
      if (!lb) return;
      lb.classList.remove('is-open'); lb.hidden = true;
      if (lbImg) lbImg.src = '';
      lockScroll(false);
    }
    if (lb) {
      lb.addEventListener('click', function (e) {
        if (e.target === lb || (e.target.closest && e.target.closest('[data-ymtp-lb-close]')) || e.target === lbImg) closeLb();
      });
    }

    /* ---------------- size guide overlay ---------------- */
    var sg = root.querySelector('[data-ymtp-sg]');
    function openSg() { if (!sg) return; sg.hidden = false; sg.classList.add('is-open'); lockScroll(true); }
    function closeSg() { if (!sg) return; sg.classList.remove('is-open'); sg.hidden = true; lockScroll(false); }
    if (sg) {
      sg.addEventListener('click', function (e) {
        if (e.target === sg || (e.target.closest && e.target.closest('[data-ymtp-sg-close]'))) closeSg();
      });
    }

    root.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('[data-ymtp-sg-open]')) { e.preventDefault(); openSg(); return; }
      if (e.target.closest('[data-ymtp-open-deliv]')) { e.preventDefault(); openDeliv(); return; }
      var img = e.target.closest('.ymtp-shot img');
      if (img) openLb(img.getAttribute('data-zoom') || img.currentSrc || img.src, img.alt);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { closeLb(); closeSg(); }
    });

    /* the shipping info row opens the Delivery & returns accordion */
    function openDeliv() {
      var box = root.querySelector('[data-ymtp-acc]');
      if (!box) return;
      var ds = box.querySelectorAll('details');
      for (var n = 0; n < ds.length; n++) {
        var sum = ds[n].querySelector('summary');
        var txt = sum ? (sum.textContent || '').toLowerCase().trim() : '';
        if (txt.indexOf('delivery') === 0) {
          ds[n].open = true;
          ds[n].scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
      }
    }

    /* ---------------- accordions: one open at a time ---------------- */
    var accBox = root.querySelector('[data-ymtp-acc]');
    if (accBox) {
      var dets = accBox.querySelectorAll('details');
      for (var k = 0; k < dets.length; k++) {
        (function (det) {
          det.addEventListener('toggle', function () {
            if (!det.open) return;
            for (var m = 0; m < dets.length; m++) { if (dets[m] !== det) dets[m].open = false; }
          });
        })(dets[k]);
      }
    }

    refreshSizeAvailability();

    /* No size is ever preselected by script. The ONE deliberate exception, mirrored from the Liquid:
       a product whose Size option has a single value has nothing to choose, so that size is selected
       (the Liquid already rendered it checked; this only repairs it if availability refresh cleared it). */
    if (CFG.singleSize === true) {
      var only = sizeInputs();
      if (only.length === 1 && !only[0].disabled && !only[0].checked) only[0].checked = true;
    }
    /* A hidden id left over from the server (e.g. ?variant= pointing at an unavailable size whose radio
       could not be checked) must not be submittable while no size radio is checked. */
    if (idInput && sizeMissing()) idInput.value = '';

    sync();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-ymtp]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
